import React, { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from 'react';

export interface SeoData {
  title: string;
  description: string;
  ogType: 'website' | 'article' | 'product';
  ogImage: string;
  canonicalUrl: string;
  robots: 'index,follow' | 'noindex,follow';
  schema: object | object[] | null;
}

interface SeoContextType {
  seoData: SeoData | null;
  setSeoData: Dispatch<SetStateAction<SeoData | null>>;
}

const SeoContext = createContext<SeoContextType | undefined>(undefined);

export const SeoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [seoData, setSeoData] = useState<SeoData | null>(null);

  return (
    <SeoContext.Provider value={{ seoData, setSeoData }}>
      {children}
    </SeoContext.Provider>
  );
};

export const useSeoContext = () => {
  const context = useContext(SeoContext);
  if (context === undefined) {
    throw new Error('useSeoContext must be used within a SeoProvider');
  }
  return context;
};